/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
    selector: 'app-file-systems-detail',
    templateUrl: './file-systems-detail.component.html',
})
export class FileSystemsDetailComponent {
    data;
}
